const aaa = [
	{
		path: "housePeizhi",
		component: () => import("@/views/housePeizhi/housePeizhi.vue"),
		meta:{title:'区域设置'},
	},
]
export default aaa;